import { DebtServicePath } from "utils/constants";

export const debtsRequests = {
  getDebtsByIds: () => `${DebtServicePath}debts/by-ids`,
  getUserDebtsById: id => `${DebtServicePath}users/${id}/debts`,
  getDebtTransactions: id => `${DebtServicePath}debts/${id}/transactions`,
  postDebtPayment: id => `${DebtServicePath}debts/${id}/payments`,
  getDebtTypesSelect: () => `${DebtServicePath}debts/types/select`,
};
